<script lang="ts">
	import Attachments from "@components/Attachments.svelte";
	import BackToTop from "@components/BackToTop.svelte";
	import BookMeeting from "@components/BookMeeting.svelte";
	import Photogallery from "@components/Photogallery.svelte";
	import Section from "@components/Section.svelte";
	import ServicesCards from "@components/ServicesCards.svelte";
	import CkEditorContent from "@components/common/CkEditorContent.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Media from "@components/common/Media.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { toDateMonthYearFormat } from "@core/utils/toDateMonthYearFormat.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { BookMeetingPerson, getBookMeetingPeople } from "../data/getBookMeetingPeople.js";
	import { getServices } from "../data/getServices.js";
	import type { NewsDetailProps } from "./NewsDetailProps.js";

	const { news }: NewsDetailProps = $props();
	const { tenant } = getGlobalTemplateProps();

	const contacts = $derived(getBookMeetingPeople(tenant));
	const lightbox = news.id;
</script>

<Layout ogImage={news.primaryImage}>
	<div class="w-full lg:max-w-3xl article">
		<h1 class="mb-3 mt-8 sm:mb-4 sm:mt-12">{news.title}</h1>
		<time
			datetime={news.publishedAt}
			class="text-fstgrey-400 mb-8 flex items-center gap-2 text-sm font-medium tracking-wide sm:mb-10"
		>
			<span class="bg-fstgreen inline-block h-1.5 w-1.5 rounded-full" aria-hidden="true"></span>
			{toDateMonthYearFormat(news.publishedAt, tenant.locale)}
		</time>
		{#if news.primaryImage}
			<Media
				{lightbox}
				source={news.primaryImage}
				sourcesets={{
					/* TODO podle toho jak to teda nakonec bude nastylované :) */
				}}
				class="w-full h-72 rounded-lg object-cover mb-6"
				alt={news.title}
				height={384}
				width={1231}
			/>
		{/if}
		<p class="text-fstonyx text-lg font-medium leading-8 sm:text-xl sm:leading-9">
			<Formatted text={news.perex} />
		</p>

		<CkEditorContent class="mb-24 mt-10" html={news.content} lightboxId={lightbox} />
	</div>
	{#if news.images.length > 0}
		<h2 class="mb-6">Fotogalerie</h2>
		<Photogallery class="full-width mb-12" images={news.images} {lightbox} />
	{/if}

	{#if news.attachments.length > 0}
		<h2 class="mb-6">Přílohy</h2>
		<Attachments class="mb-12" attachments={news.attachments} />
	{/if}

	<Section centered gridHeadline="container-6" noPadding="bot">
		{#snippet headline()}
			<Formatted text="S čím vám mimo jiné cg[[pomůžeme]]" />
		{/snippet}
	</Section>
	<ServicesCards cards={getServices(tenant)} />
	<Section noPadding="top" />
	<BookMeeting contacts={[contacts[BookMeetingPerson.Kucera]]} />
	<BackToTop />
</Layout>
